import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  Rating,
  TextField,
} from '@mui/material';
import { Comment as CommentIcon } from '@mui/icons-material';
import { DialogTitleWithClose } from '../../common';

const FeedbackDialog = ({
  open,
  onClose,
  newFeedback,
  setNewFeedback,
  onSubmitFeedback,
  title = 'Add Feedback',
  ratingLabel = 'Rate this template',
  placeholder = 'Share your experience with this template...',
}) => {
  const handleSubmit = async () => {
    try {
      await onSubmitFeedback();
    } catch (error) {
      // Failed to submit feedback
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitleWithClose
        title={
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <CommentIcon sx={{ mr: 1 }} />
            {title}
          </Box>
        }
        onClose={onClose}
      />
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <Typography variant="subtitle2" gutterBottom>
            {ratingLabel}
          </Typography>
          <Rating
            value={newFeedback.rating}
            onChange={(event, newValue) => {
              setNewFeedback(prev => ({ ...prev, rating: newValue }));
            }}
            size="large"
            sx={{ mb: 3 }}
          />

          <Typography variant="subtitle2" gutterBottom>
            Your feedback (optional)
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            value={newFeedback.comment}
            onChange={e =>
              setNewFeedback(prev => ({ ...prev, comment: e.target.value }))
            }
            placeholder={placeholder}
            variant="outlined"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={newFeedback.rating === 0}
        >
          Submit Feedback
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackDialog;
